import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  useMediaQuery,
} from "@chakra-ui/react";

const Info = ({
  isOpen,
  onClose,
}: {
  onClose: () => void;
  isOpen: boolean;
}) => {
  const [isMedium] = useMediaQuery(["(min-width: 768px)"]);

  return (
    <Drawer
      onClose={onClose}
      isOpen={isOpen}
      size={isMedium ? "sm" : "full"}
      placement={"left"}
    >
      <DrawerOverlay />
      <DrawerContent className="!h-[calc(100dvh-64.8px)] md:!h-full">
        <DrawerCloseButton />
        <DrawerHeader className="text-rss-primary-color">RSS FEED</DrawerHeader>
        <DrawerBody className="custom-scroll">
          <p>
            Gli feed RSS (dall'inglese Really Simple Syndication) sono
            aggregatori di notizie: grazie a questo sistema è possibile ricevere
            sul proprio computer la notifica da parte dei siti delle riviste
            scientifiche che offrono questo servizio della pubblicazione di
            articoli su un tema di interesse
          </p>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default Info;
